
import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../user.service';
import { AuthenticationService } from '../authentication.service';
import { NavigationService } from '../navigation.service';

@Injectable({
  providedIn: 'root'
})
export class IdleSessionService {

  constructor(
    private idle: Idle,
    private userService: UserService,
    private authService: AuthenticationService,
    private navigation: NavigationService,
    private toaster: ToastrService
  ) { }

  // ▶ START SESSION TIMEOUT
  start() {

    // 🔥 RESET NG-IDLE STATE (CRITICAL)
    this.idle.stop();
    this.idle.clearInterrupts();
    this.idle.ngOnDestroy();

    // ⏱ TOTAL 3 SECONDS
    this.idle.setIdle(900);
    this.idle.setTimeout(30);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      console.log('User is idle');
    });

    this.idle.onTimeout.subscribe(() => {
      console.log('Session timed out');
      this.stop();
      this.userService.logout(true).subscribe(() => {
        this.authService.logOut();
        this.navigation.goToLogin();
        this.toaster.warning(
          'Your session has timed out. Please log in again.'
        );
      });
    });

    // ✅ START WATCHING
    this.idle.watch();
  }

  // ⏹ STOP SESSION TIMEOUT
  stop() {
    this.idle.stop();
    this.idle.clearInterrupts();
    this.idle.ngOnDestroy();
  }
}
